module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('search-block-main'), _vm._v(" "), _c('div', {
    staticClass: "belt"
  }, [(_vm.searchResultsList.length != 0) ? _c('div', {
    staticClass: "belt__container"
  }, [_c('div', {
    staticClass: "belt__boxes"
  }, [_c('div', {
    staticClass: "belt__box belt__box--left"
  }, [_c('items-per-page'), _vm._v(" "), _c('sort-dropdown')], 1), _vm._v(" "), _c('div', {
    staticClass: "belt__box belt__box--right"
  }, [_c('pagination-with-input')], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "search__container"
  }, [_c('div', {
    staticClass: "search__boxes"
  }, [_c('div', {
    staticClass: "search__box search__box--left"
  }, [_c('div', {
    staticClass: "block block--info"
  }, [_c('div', {
    staticClass: "block__title"
  }, [_c('h3', {
    staticClass: "block__title--text"
  }, [_vm._v(_vm._s(_vm.$lang.search.info.title))])]), _vm._v(" "), _c('div', {
    staticClass: "block__content"
  }, [_c('search-info')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block block--filters"
  }, [_c('div', {
    staticClass: "block__title"
  }, [_c('h3', {
    staticClass: "block__title--text"
  }, [_vm._v(_vm._s(_vm.$lang.filters.title))])]), _vm._v(" "), _c('div', {
    staticClass: "block__content"
  }, [_c('search-filters')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "search__box search__box--right"
  }, [_c('div', {
    staticClass: "block block--results"
  }, [_c('div', {
    staticClass: "block__title"
  }, [_c('h3', {
    staticClass: "block__title--text"
  }, [_vm._v(_vm._s(_vm.$lang.search.results.title))])]), _vm._v(" "), _c('div', {
    staticClass: "block__content"
  }, [_c('search-results')], 1)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-423b1526"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/Search.vue
// module id = 336
// module chunks = 1